var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('api-loader',{attrs:{"method":"get","url":"v1/layeradmin/batches/expanded"},on:{"loaded":function($event){_vm.batches=$event}}}),_vm._v(" "),(_vm.batches && _vm.batches.length > 0)?_c('admin-overview-reports',{attrs:{"batches":_vm.batches}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d1ed8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layerAdmin/components/AdminOverviewReportsContainer.vue
// module id = null
// module chunks = 